import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Row, Col, notification, Divider } from 'antd'
import Search from 'antd/es/input/Search';
import React, { useState } from 'react'
import { postPhotosSearch } from '../../services/api';
import { PhotosWrap } from '../../styles/global';
import Loader from '../loader';
import Photo from '../photo';
import PhotoSearch from '../photo/search';

type ModalPhotoSearchType = {
    isOpen: boolean;
    contentId?: any;
}

const ModalPhotoSearch = ({isOpen, contentId}: ModalPhotoSearchType) => {

    const queryClient = useQueryClient();
    const [ ntf, contextHolder ] = notification.useNotification();
    const { mutate: mutatePostPhotosSearch, isLoading } = useMutation(postPhotosSearch);

    const [results, setResults] = useState([])
    
    const handleSearch = (value: string) => {
        mutatePostPhotosSearch({ description: value }, {
            onSuccess: (response) => {
                setResults(response);
            },
            onError() {
                ntf.error({
                    message: `Error`,
                    description: "Something gonne wrong!",
                    placement: "bottomLeft",
                });
            },
        })
    }
    
    if (!isOpen) {
        return <></>
    }
    
    return (
        <div>
            {contextHolder}
            <Row gutter={16}>
                <Col span={24}>
                    <Search placeholder="Search Photo Store" onSearch={handleSearch} enterButton />
                </Col>
                <Col span={24}>
                    <Divider>Results</Divider>
                    {isLoading && <Loader />}
                    <PhotosWrap>
                        {results && results.map((photo: any) => {
                            return <PhotoSearch alt={photo.description} src={photo.name} photoId={photo.id} contentId={contentId} />
                        })} 
                    </PhotosWrap>
                </Col>
            </Row>
        </div>
    )
}

export default ModalPhotoSearch